<!--
  `picture` serve o WebP a quem aceita e cai no PNG no resto. O PNG continua sendo o arquivo do
  `src`, então cliente sem suporte a WebP e leitor de e-mail não ficam sem imagem.
-->
<picture class="block">
  <source type="image/webp" [srcset]="webp()" />
  <img [src]="png()" class="w-full h-auto" alt="Menii" />
</picture>
